import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { Zone } from "@app/models/rest/zone";

@Injectable({
  providedIn: "root"
})
export class ZoneRestService extends HateoasResourceOperation<Zone> {
  constructor() {
    super(Zone);
  }
}
